module.exports = __webpack_public_path__ + "img/btn-confirm.817a6da6.png";